import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios, { AxiosProgressEvent } from "axios";
import ProposalCover from "./Templates/Template-1/ProposalCover";
import CommonValues from "../common/utils";
import GeneratedProposal from "./GeneratedProposal";
import { Button } from "primereact/button";
import html2pdf from "html2pdf.js";
import AtkButton from "../AtlaskitControls/AtkButton";
import AtkButtonIconBefore from "../AtlaskitControls/AtkButtonIconBefore";
import DownloadIcon from "@atlaskit/icon/glyph/download";

export default function PreviewStep(props: any) {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState<number>(0);
  const [processing, setProcessing] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const toast: any = useRef("");
  const navigate = useNavigate();
  const proposalRef = useRef(null);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  useEffect(() => {
    generateQuote();
  }, []);

  const generateQuote = () => {
    setLoading(true);
    setProgress(0);
    setProcessing(false);

    // let documentType = "";
    // if (props.selectedPolicy?.linesOfBusiness?.length > 0) {
    //   documentType = props.selectedPolicy.linesOfBusiness[0].toLowerCase().includes("auto") ? "Auto" : props.selectedPolicy.linesOfBusiness[0];
    // } else {
    //   documentType = "";
    // }

    let data = new FormData();
    if (props.selectedFile) {
      data.append("file", props.selectedFile);
    }
    let policy: any = {};
    let quote: any = {};
    if (props.selectedPolicy && Object.keys(props.selectedPolicy).length > 0) {
      const lines = props.selectedPolicy.linesOfBusiness;

      policy = {
        Total_Premium: props.selectedPolicy.totalPremium ?? "",
        Effective_Date: props.selectedPolicy.effectiveDate ?? "",
        Policy_Number: props.selectedPolicy.policyNumber ?? "",
        Line_Of_Business: Array.isArray(lines) && lines.length > 0 ? lines[0] : "",
        Carrier_Name: props.selectedPolicy.carrierName,
        Term: props.selectedPolicy.policyTermInMonths,
        Expiration_Date: props.selectedPolicy.expirationDate,
        client_Name: props.clientName,
      };
    }
    if (props.selectedQuote && Object.keys(props.selectedQuote).length > 0) {
      const lines = props.selectedQuote.linesOfBusiness;

      quote = {
        Total_Premium: props.selectedQuote.totalPremium ?? "",
        Effective_Date: props.selectedQuote.effectiveDate ?? "",
        Policy_Number: props.selectedQuote.policyNumber ?? "",
        Line_Of_Business: Array.isArray(lines) && lines.length > 0 ? lines[0] : "",
        Carrier_Name: props.selectedQuote.carrierName,
        Term: props.selectedQuote.policyTermInMonths,
        Expiration_Date: props.selectedQuote.expirationDate,
        client_Name: props.clientName,
        coverage_Details: props.coverageDetails,
        driverList: props.driverList,
        vehicleList: props.vehicleList,
      };
    }

    data.append("documentType", props.documentType);
    data.append("templateId", props.selectedTemplate);
    data.append("videoUrl", props.videoUrl ?? "");
    data.append("policyDetails", JSON.stringify(policy) ?? "");
    data.append("quoteDetails", JSON.stringify(quote) ?? "");
    data.append("draftTransactionId", window.location.pathname.split("/")[2]);
    data.append("fileName", props.fileName);
    data.append("clientName", props.clientName);

    axios
      .post(`${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/generate`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        },
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setProgress(percentCompleted);

            if (percentCompleted >= 100) {
              setProcessing(true);
            }
          }
        },
      })
      .then((response: any) => {
        setTransactionId(response.data.transactionId);
        props.setTransactionId(response.data.transactionId);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
        setProcessing(false);
      });
  };

  const onPreviewClicked = (e: any) => {
    e.preventDefault();
    if (transactionId != "" && transactionId != null) {
      window.open(`/quoteproposal/${transactionId}`);
    }
  };
  const onDownloadClicked = () => {
    setIsGeneratingPdf(true);
    if (!proposalRef.current) return;

    setTimeout(() => {
      const opt = {
        margin: 0.5,
        filename: `Proposal-${transactionId}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      html2pdf()
        .set(opt)
        .from(proposalRef.current)
        .save()
        .then(() => {
          setIsGeneratingPdf(false);
        })
        .catch(() => {
          setIsGeneratingPdf(false);
        });
    }, 500);
  };
  return (
    <div className="card border-0">
      <div className="border-bottom pb-3 px-4 pt-4">
        <h6 className="mb-1">Preview & Send</h6>
        <p className="text-muted mb-0 text-12">Review and send proposal</p>
      </div>

      <div className="card-body pt-4 px-4">
        <div className="mb-3">
          <label htmlFor="file-upload" className="form-label fw-medium text-14 mb-0">
            Preview Your Proposal
          </label>
          <p className="text-muted small">Review the AI-generated proposal based on the uploaded document or selected quote and selected template.</p>

          {loading ? (
            <div style={{ width: "300px", margin: "50px auto", textAlign: "center" }}>
              {!processing ? (
                <>
                  <p>Uploading File... {progress}%</p>
                  <div style={{ width: "100%", backgroundColor: "#eee", borderRadius: "8px", overflow: "hidden" }}>
                    <div
                      style={{
                        height: "20px",
                        width: `${progress}%`,
                        backgroundColor: progress >= 100 ? "#2ecc71" : "#3498db",
                        transition: "width 0.3s ease",
                      }}
                    ></div>
                  </div>
                </>
              ) : (
                <>
                  <p className="d-flex align-items-center justify-content-center">
                    Processing Proposal...
                    <div className="spinner-border text-purple ms-2 " role="status">
                      <span className="visually-hidden">Processing...</span>
                    </div>
                  </p>
                </>
              )}
            </div>
          ) : (
            <div className="card p-3">
              <div className="text-end">
                {transactionId != "" && transactionId != null ? (
                  <>
                    <a href="" onClick={onPreviewClicked}>
                      Preview Proposal
                    </a>
                    <AtkButtonIconBefore
                      label="Download"
                      onClick={onDownloadClicked}
                      iconBefore={<DownloadIcon label="" />}
                      className="pf-primary-btn w-auto ms-2 "
                      title="Download as pdf"
                    />
                  </>
                ) : null}
              </div>
              <div ref={proposalRef}>
                <GeneratedProposal
                  transactionId={transactionId}
                  selectedPolicy={props.selectedPolicy}
                  selectedTemplate={props.selectedTemplate}
                  videoUrl={props.videoUrl}
                  isEditable={true}
                  isGeneratingPdf={isGeneratingPdf}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
